import { useRef, useEffect } from 'react';

export function usePreviousUniqueValue<T>(value: T): T {
    const ref = useRef<T>(value);

    useEffect(
        function updateWhenValueChanges() {
            ref.current = value;
        },
        [value]
    );

    return ref.current;
}
